import { useServices } from '@/app/providers';
import { useCrudNotifications } from '@/shared/hooks';
import { useState } from 'react';

export function useRoutineActions(onSuccess: () => void) {
  const { routineRepo } = useServices();
  const [loadingId, setLoadingId] = useState<string | null>(null);

  const { withNotification, withUpdateNotification, withDeleteNotification } = useCrudNotifications({
    entityName: 'Rutina',
  });

  const toggleRoutine = async (id: string, enabled: boolean, name: string) => {
    setLoadingId(id);
    try {
      await withNotification(
        () => routineRepo.toggle(id, enabled),
        enabled ? `Rutina "${name}" reanudada` : `Rutina "${name}" pausada`,
      );
      onSuccess();
    } finally {
      setLoadingId(null);
    }
  };

  const deleteRoutine = async (id: string) => {
    setLoadingId(id);
    try {
      await withDeleteNotification(() => routineRepo.delete(id));
      onSuccess();
    } finally {
      setLoadingId(null);
    }
  };

  const triggerRoutine = async (id: string): Promise<string | null> => {
    setLoadingId(id);
    try {
      const result = await routineRepo.trigger(id);
      return result.executionId;
    } catch {
      return null;
    } finally {
      setLoadingId(null);
    }
  };

  return { toggleRoutine, deleteRoutine, triggerRoutine, loadingId };
}
